import { render } from "./salary-model.vue?vue&type=template&id=0a95519e"
import script from "./salary-model.vue?vue&type=script&lang=js"
export * from "./salary-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__